import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { requestStore, fetchInstallersForPrioritization,
  fetchCandidatesForMeasurePrioritization, resetInstallerPrioritization,
  resetMeasurePrioritization } from 'actionCreators';
import Loading from 'components/Loading';
import StoreDetailsCard from './components/storeDetailsCard';
import { getRole, getStoreById, getPricePatchById,
  getStoreInstallerPrioritization, getStoreMeasurePrioritization } from '../../../../reducers';
import { can } from '../../../../services';
import connectUI from 'redux-ui';
import MessageBox from 'components/MessageBox';

class StoreDetails extends React.Component {
  componentDidMount() {
    const { id, dispatch } = this.props;
    dispatch(requestStore(id)).then(() => {
      dispatch(fetchInstallersForPrioritization(id));
      dispatch(fetchCandidatesForMeasurePrioritization(id));
    });
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    if (this.props.ui.successMessage) {
      this.props.updateUI('successMessage', '');
    }
    dispatch(resetInstallerPrioritization());
    dispatch(resetMeasurePrioritization());
  }

  render() {
    const { loading, store, canEdit, ui, pricePatch,
      installerPrioritization, measurePrioritization } = this.props;
    return (
      <div>
        {ui.successMessage ? <MessageBox message={ui.successMessage} /> : null}
        {
          loading ?
            <Loading /> :
            <StoreDetailsCard
              canEdit={canEdit}
              store={store}
              pricePatch={pricePatch}
              installerPrioritization={installerPrioritization}
              measurePrioritization={measurePrioritization}
            />
        }
      </div>
    );
  }
}

StoreDetails.propTypes = {
  loading: PropTypes.bool,
  canEdit: PropTypes.bool,
  store: PropTypes.object,
  ui: PropTypes.object,
  updateUI: PropTypes.func,
  id: PropTypes.number,
  dispatch: PropTypes.func,
  pricePatch: PropTypes.object,
  installerPrioritization: PropTypes.object,
  measurePrioritization: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  const id = Number(ownProps.params.id);
  const store = getStoreById(state)(id);
  const loading = store ? store.loading : true;
  const pricePatch = loading ? null : getPricePatchById(state)(store.price_patch) || {};
  const role = getRole(state);
  return {
    id,
    store,
    canEdit: can(role, 'update', 'store'),
    loading,
    pricePatch,
    installerPrioritization: getStoreInstallerPrioritization(state),
    measurePrioritization: getStoreMeasurePrioritization(state),
  };
}

export default connectUI()(connect(mapStateToProps)(StoreDetails));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/stores/storeDetails.jsx